export function scrollToService() {
  function scrollTo(url, event) {
    let urlArray = url.split("#");

    if (urlArray[1]) {
      let block = $(`[data-id="${urlArray[1]}"]`);

      if (block.length) {
        if (event) {
          event.preventDefault();
        }

        $("body, html").animate({
          scrollTop: parseInt(block.offset().top) - 20
        }, 500);
      }
    }
  }

  scrollTo(window.location.href);

  $(".footer-nav").on("click", 'a', function (e) {
    scrollTo($(this).attr("href"), e);
  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/scrollToService.js